import NbsApis from 'Src/const/nbsApis'
import { isBp } from 'Src/util/tool'

export const ADVERTISER = 'advertiser'
const LIMIT = 20
const SEARCH_LIIMIT = 50

export const levelConfig = {
  [ADVERTISER]: {
    valueKey: `${ADVERTISER}_ids`,
    id: `${ADVERTISER}_id`, // 后端返回接口id的key
    key: `accounts`, // 后端返回接口数组的key, data.accounts为相应数据
    name: `${ADVERTISER}_name`, // 后端返回接口name的key,
    cascadeUrl: NbsApis.reporter.adv_list_bp, // todo: 在node提供一个全量查询的接口
    searchUrl: NbsApis.reporter.advertiser_search,
    searchPlaceholder: '请输入名称搜索',
    label: $bp_t('广告账户', 'bp.const_pricing_advertising_account'),
    lazyLoad: true,
    pageLimit: LIMIT,
    searchPageLimit: SEARCH_LIIMIT,
    cascadePageUrl: NbsApis.reporter.adv_list_bp
  }
}

export const levelList = isBp() ? Object.keys(levelConfig) : []

export const getData = (options = {}, vm) => {
  const { url, data } = options
  return new Promise((resolve, reject) => {
    return BUI.fetch({
      url,
      data,
      success: (resp) => {
        if (resp.code === 0) {
          resolve(resp)
        } else {
          vm.$message(resp.msg || '系统错误', 'error')
          reject(resp)    //  eslint-disable-line
        }
      },
      error: (error) => {
        vm.$message(error.msg || '系统错误', 'error')
        reject(error)     //  eslint-disable-line
      }
    })
  })
}
